import { useEffect, useState } from "react";
import { Card, message, Spin } from "antd";
import {
  Users,
  Image,
  IndianRupee,
  Coins,
  TrendingUp,
  CreditCard,
  Headphones,
} from "lucide-react";

import axios from "axios";
import AdminLayout from "../Components/AdminLayout";
import reapi from "../../../api/reapi";

export default function Dashboard() {
  const [loading, setLoading] = useState(false);
  const [dashboard, setDashboard] = useState(null);

  const token = localStorage.getItem("meeshoadminToken");

  const fetchDashboard = async () => {
    try {
      setLoading(true);

      

      const res = await reapi.get("/adm/dashboard", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setDashboard(res.data.data);
    } catch (error) {
      message.error(
        error?.response?.data?.message || "Dashboard load failed"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, []);

 

  const stats = dashboard?.stats || {};

  return (

      <Spin spinning={loading} tip="Loading dashboard...">
        <div>
          <h1 className="text-4xl font-bold m-0">Dashboard</h1>
          <p className="text-slate-500 mt-2">
            Admin overview of users, optimizations, payments and support.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-5 gap-5 mt-8">
            <StatCard
              title="Total Users"
              value={stats.totalUsers || 0}
              icon={<Users />}
              color="purple"
            />

            <StatCard
              title="Optimizations"
              value={stats.totalOptimizations || 0}
              icon={<Image />}
              color="blue"
            />

            <StatCard
              title="Revenue"
              value={`₹${stats.totalRevenue || 0}`}
              icon={<IndianRupee />}
              color="green"
            />

            <StatCard
              title="Credits Sold"
              value={stats.totalCreditsSold || 0}
              icon={<Coins />}
              color="orange"
            />

            <StatCard
              title="Savings"
              value={`₹${stats.totalSavingsGenerated || 0}`}
              icon={<TrendingUp />}
              color="green"
            />

            <StatCard
              title="Credits Used"
              value={stats.totalCreditsUsed || 0}
              icon={<Coins />}
              color="red"
            />

            <StatCard
              title="Payments"
              value={stats.totalPayments || 0}
              icon={<CreditCard />}
              color="blue"
            />

            <StatCard
              title="Pending Support"
              value={stats.pendingSupport || 0}
              icon={<Headphones />}
              color="purple"
            />
          </div>

          <div className="grid grid-cols-1 xl:grid-cols-3 gap-5 mt-8">
            <RecentCard
              title="Recent Users"
              data={dashboard?.recentUsers || []}
              renderItem={(item) => (
                <>
                  <b>{item?.name || "User"}</b>
                  <span>{item?.email}</span>
                  <small>Wallet: {item?.wallet || 0} credits</small>
                </>
              )}
            />

            <RecentCard
              title="Recent Optimizations"
              data={dashboard?.recentOptimizations || []}
              renderItem={(item) => (
                <>
                  <b>{item.category || "Optimization"}</b>
                  <span>
                    ₹{item.originalshipping} → ₹{item.optimizedshipping}
                  </span>
                  <small className="text-green-600">
                    Saved ₹{item.savings || 0}
                  </small>
                </>
              )}
            />

            <RecentCard
              title="Recent Payments"
              data={dashboard?.recentPayments || []}
              renderItem={(item) => (
                <>
                  <b>{item.txnname || "Payment"}</b>
                  <span>₹{item.amount || 0}</span>
                  <small>{item.status}</small>
                </>
              )}
            />
          </div>
        </div>
      </Spin>
   
  );
}

function StatCard({ title, value, icon, color }) {
  const colors = {
    purple: "bg-purple-100 text-purple-600",
    blue: "bg-blue-100 text-blue-600",
    green: "bg-green-100 text-green-600",
    orange: "bg-orange-100 text-orange-600",
    red: "bg-red-100 text-red-600",
  };

  return (
    <Card className="rounded-2xl shadow-sm">
      <div className="flex items-center gap-4">
        <div
          className={`w-14 h-14 rounded-xl flex items-center justify-center ${colors[color]}`}
        >
          {icon}
        </div>

        <div>
          <p className="text-slate-500 m-0">{title}</p>
          <h2 className="text-3xl font-extrabold m-0 mt-1">{value}</h2>
        </div>
      </div>
    </Card>
  );
}

function RecentCard({ title, data, renderItem }) {
  return (
    <Card title={title} className="rounded-2xl shadow-sm">
      {data.length === 0 ? (
        <p className="text-slate-500 m-0">No data found</p>
      ) : (
        <div className="space-y-4">
          {data.slice(0, 5).map((item) => (
            <div
              key={item._id}
              className="border-b last:border-b-0 pb-3 flex flex-col"
            >
              {renderItem(item)}
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}